import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from "./App"
import "./index.css";
import { ContextProvider } from "./contexts/ContextProvider";
import { AuthProvider } from "./contexts/AuthContext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <AuthProvider>
        <ContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={<App />} />
                </Routes>
            </BrowserRouter>
        </ContextProvider>
    </AuthProvider>
);
// serviceWorkerRegistration.register();
// serviceWorkerRegistration.register({ onUpdate: () => window.location.reload() });

// serviceWorkerRegistration.register({
//     onUpdate: () => {
//         console.log("🔁 Service Worker updated");
//     },
// });
//<React.StrictMode> remove
